/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023, 2024.
 */

import { useAllPhysicalStores } from '@/data/Content/PhysicalStoreFetchAll';
import { useStoreLocatorState } from '@/data/state/useStoreLocatorState';
import { useCookies } from 'react-cookie';

/**
 * React hook used on PDP elements to get the currents physicalStore and
 * unique ID
 */
type PhysicalStore = {
	storeName: string;
	uniqueID: string;
};

export const useStoreIDS = () => {
	const [cookies] = useCookies(['geoLocationHDP']);
	const { storeLocator } = useStoreLocatorState();
	const geoLocationHDP = cookies.geoLocationHDP;
	const physicalStoreId =
		!geoLocationHDP?.stLocId || geoLocationHDP?.stLocId === storeLocator.selectedStore.id
			? storeLocator.selectedStore.id
			: geoLocationHDP?.stLocId;
	const allPhysicalStores = useAllPhysicalStores();
	const physicalStoreIdsList = allPhysicalStores.physicalStores?.DataList?.[0]?.PhysicalStore as [];

	const physicalStoreIdData = physicalStoreIdsList?.find(
		({ storeName }) => storeName === physicalStoreId
	) as PhysicalStore | undefined;
	const uniqueID = physicalStoreIdData?.uniqueID ?? '';

	return { physicalStoreId, uniqueID };
};
